module.exports = __webpack_public_path__ + "img/avatar5.09ce8c26.png";